import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SPECIALITIES_CONSTANT } from "../constants/SpecialityConstant";

export function getSpecialities(
  id,
  closeMenu = () => {},
  setTab,
  setSpecialityId = () => {}
) {
  const properties = [];
  for (const key in SPECIALITIES_CONSTANT) {
    if (SPECIALITIES_CONSTANT.hasOwnProperty(key)) {
      properties.push(
        <li
          key={key}
          className={`${id === key ? "active" : ""}`}
          onClick={() => {
            closeMenu();
            setTab("speciality");
            setSpecialityId(key);
          }}
        >
          <Link to={`/specialities/${key}`} key={key}>
            {SPECIALITIES_CONSTANT[key]}
          </Link>
        </li>
      );
    }
  }
  return properties;
}

export const Navbar = ({ tab, setTab, specialityId, setSpecialityId }) => {
  const [isMobileMenu, setIsMobileMenu] = useState(false);
  const [showServices, setShowServices] = useState(false);

  const closeMenu = () => {
    setIsMobileMenu(false);
  };

  return (
    <header id="masthead" className="header ttm-header-style-01 clearfix">
      <div className="top_bar ttm-bgcolor-darkgrey ttm-textcolor-white clearfix">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="d-flex flex-row align-items-center justify-content-center">
                <div className="ttm-bg ttm-col-bgcolor-yes ttm-left-span ttm-bgcolor-skincolor ttm-textcolor-white mr-auto padding_right25">
                  <div className="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>
                  <div className="layer-content">
                    <div className="top_bar_contact_item">
                      <div className="top_bar_icon">
                        <i className="ti ti-timer"></i>
                      </div>
                      Open Hours: Monday - Sunday 10 AM to 06 PM
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="top_bar_contact_item">
                    <div className="top_bar_icon">
                      <i className="fa fa-envelope-o"></i>
                    </div>
                    <a href="mailto:prasadeyehospital021@gmail.com">
                      prasadeyehospital021@gmail.com
                    </a>
                  </div>
                  <div className="top_bar_contact_item">
                    <div className="top_bar_icon">
                      <i className="fa fa-phone"></i>
                    </div>
                    <a href="tel:7970479666">+91 7970479666</a>
                  </div>
                  <div className="top_bar_contact_item top_bar_social">
                    <ul className="social-icons">
                      <li className="facebook-icon">
                        <a
                          href="https://www.facebook.com/pehramgarh/"
                          aria-label="facebook"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          <i className="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li className="instagram-icon">
                        <a
                          href="https://www.instagram.com/pehramgarh/"
                          rel="noopener noreferrer"
                          target="_blank"
                          aria-label="instagram"
                        >
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="twitter-icon">
                        <a
                          href="https://x.com/PEH_Ramgarh/"
                          rel="noopener noreferrer"
                          target="_blank"
                          aria-label="twitter"
                        >
                          <i className="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li className="youtube-icon">
                        <a
                          href="https://www.youtube.com/@prasadeyehospital"
                          rel="noopener noreferrer"
                          target="_blank"
                          aria-label="youtube"
                        >
                          <i className="fa fa-youtube"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="site-header-menu" className="site-header-menu">
        <div className="site-header-menu-inner ttm-stickable-header">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="site-navigation d-flex flex-row align-items-center justify-content-between">
                  <div className="site-branding ">
                    <Link
                      to="/"
                      className="home-link"
                      title="Prasad Eye Hospital"
                      onClick={() => {
                        setTab("home");
                      }}
                    >
                      <img
                        id="logo-img"
                        className="img-center"
                        src="https://prasad-eye-hospital-public.s3.ap-south-1.amazonaws.com/images/logo.png"
                        alt="logo"
                      />
                    </Link>
                  </div>
                  <div className="d-flex flex-row">
                    <div
                      className={`btn-show-menu-mobile menubar menubar--squeeze ${
                        isMobileMenu ? "is-active" : ""
                      }`}
                      onClick={() => setIsMobileMenu(!isMobileMenu)}
                    >
                      <span className="menubar-box">
                        <span className="menubar-inner"></span>
                      </span>
                    </div>
                    <nav
                      className={`main-menu menu-mobile  ${
                        isMobileMenu ? "show" : ""
                      }`}
                      id="menu"
                    >
                      <ul className="menu">
                        <li
                          className={`mega-menu-item ${
                            tab === "home" ? "active" : ""
                          }`}
                          onClick={() => {
                            closeMenu();
                            setTab("home");
                          }}
                        >
                          <Link to="/">Home</Link>
                        </li>
                        <li
                          className={`mega-menu-item ${
                            tab === "about" ? "active" : ""
                          }`}
                          onClick={() => {
                            closeMenu();
                            setTab("about");
                          }}
                        >
                          <Link to="/about">About Us</Link>
                        </li>
                        <li
                          className={`mega-menu-item ${
                            tab === "speciality" ? "active" : ""
                          }`}
                        >
                          <Link
                            to={"/specialities/cataract"}
                            className={`mega-menu-link ${
                              showServices ? "active" : ""
                            }`}
                            onClick={() => {
                              setTab("speciality");
                              if (isMobileMenu) setShowServices(!showServices);
                              else setShowServices(false);
                              setSpecialityId("cataract");
                            }}
                          >
                            Specialities
                          </Link>
                          <ul
                            className={`mega-submenu ${
                              showServices ? "active" : ""
                            }`}
                          >
                            {getSpecialities(
                              specialityId,
                              closeMenu,
                              setTab,
                              setSpecialityId
                            )}
                          </ul>
                        </li>
                        <li
                          className={`mega-menu-item ${
                            tab === "appointment" ? "active" : ""
                          }`}
                          onClick={() => {
                            closeMenu();
                            setTab("appointment");
                          }}
                        >
                          <Link to="/appointment">Appointment</Link>
                        </li>
                        <li
                          className={`mega-menu-item ${
                            tab === "blogs" ? "active" : ""
                          }`}
                          onClick={() => {
                            closeMenu();
                            setTab("blogs");
                          }}
                        >
                          <Link to="/blogs">Blogs</Link>
                        </li>
                        <li
                          className={`mega-menu-item ${
                            tab === "contactus" ? "active" : ""
                          }`}
                          onClick={() => {
                            closeMenu();
                            setTab("contactus");
                          }}
                        >
                          <Link to="/contactus">Contact Us</Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
